import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import rightArrowIcon from 'students/views/shared/assets/icons/arrow_right_icon.svg';
import CircleButton from '../CircleButton';
import { ICircleButton } from '../CircleButton/CircleButton';

const NextButton: React.FC<ICircleButton> = ({
  onClick,
  disabled,
  iconColor,
  shadowColor,
  size,
  bgColor,
  title,
  showSpinner,
  spinnerVariant,
  className
}) => {
  return (
    <SNextButton
      onClick={onClick}
      disabled={disabled}
      iconUrl={rightArrowIcon}
      iconColor={iconColor}
      shadowColor={shadowColor}
      size={size}
      bgColor={bgColor}
      title={title}
      showSpinner={showSpinner}
      spinnerVariant={spinnerVariant}
      className={cn(className)}
    />
  );
};

const SNextButton = styled(CircleButton)`
  font-size: 2.5rem;
  &:hover,
  &:focus {
    background-color: var(--lingu-light-btn-bg-hover);
    border-color: var(--lingu-light-btn-bg-hover);
  }
  &:active {
    background-color: var(--lingu-light-btn-bg-pressed);
    border-color: var(--lingu-light-btn-bg-pressed);
  }
`;

export default NextButton;
